import { useEffect, useState } from 'react';
import {
  services as defaultServices,
  appointmentTypes as defaultAppointmentTypes,
} from '../mockData';

const DEFAULT_CONTENT = {
  services: defaultServices,
  appointmentTypes: defaultAppointmentTypes,
};

const fetchServiceContent = async () => {
  const response = await fetch('/api/content/services', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to load services content: ${response.status}`);
  }

  return response.json();
};

export const useServiceContent = () => {
  const [services, setServices] = useState(DEFAULT_CONTENT.services);
  const [appointmentTypes, setAppointmentTypes] = useState(
    DEFAULT_CONTENT.appointmentTypes,
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const load = async () => {
      try {
        const payload = await fetchServiceContent();
        if (isCancelled) {
          return;
        }

        if (Array.isArray(payload?.services)) {
          setServices(payload.services);
        }

        if (Array.isArray(payload?.appointmentTypes)) {
          setAppointmentTypes(payload.appointmentTypes);
        }
      } catch (error) {
        if (!isCancelled) {
          console.error('Failed to load service content from backend:', error);
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isCancelled = true;
    };
  }, []);

  return {
    services,
    appointmentTypes,
    isLoading,
  };
};
